export enum PrintModes {
    AUTO = 'AUTO',
    DRAW = 'DRAW',
}

export const getPrintModesCaption = (typ: string | PrintModes): string => {
    switch (typ) {
        case PrintModes.AUTO:
            return 'Jedna stránka';
        case PrintModes.DRAW:
            return 'Více stránek (zákresem oblasti)';
        default:
            return `_${typ}`;
    }
};

export const getPrintModesItems = (): {id: PrintModes; name: string}[] => {
    return Object.keys(PrintModes).map((t: PrintModes) => ({id: t, name: getPrintModesCaption(t)}));
};
